import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { State, Tenants } from '../../../store';
import { EnquiriesTenantSettings } from './enquiries-tenant-settings.actions';
import { catchError, filter, map, of, switchMap, withLatestFrom } from 'rxjs';
import { EnquiriesService } from '@careapp-group/ng-sdk';
import { EnquiriesTenantSettingsSelectors } from './enquiries-tenant-settings.selectors';
import { TenantSelectors } from '../../../store/tenants/tenants.selectors';
import { Injectable } from '@angular/core';

@Injectable()
export class EnquiriesTenantSettingsEffects {
  getTenantSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EnquiriesTenantSettings.RequestRetrieveByIdAction),
      withLatestFrom(this.store.select(EnquiriesTenantSettingsSelectors.getEntities)),
      switchMap(([action, entities]) => {
        if (action.forceRefresh || !entities[action.id]) {
          return this.enquiriesService.getEnquiriesTenantSettings({ tenantId: action.id }).pipe(
            map((result) =>
              EnquiriesTenantSettings.ResponseSuccessRetrieveByIdAction({ payload: result }),
            ),
            catchError((error) =>
              of(
                EnquiriesTenantSettings.ResponseFailRetrieveByIdAction({
                  error: error,
                  id: action.id,
                }),
              ),
            ),
          );
        } else {
          return of(
            EnquiriesTenantSettings.ResponseSuccessRetrieveCachedByIdAction({
              payload: entities[action.id],
            }),
          );
        }
      }),
    ),
  );

  saveTenantSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EnquiriesTenantSettings.RequestUpdateAction),
      switchMap((action) => {
        return this.enquiriesService
          .putEnquiriesTenantSettings({
            createEnquiriesTenantSettingsDto: action.data,
            tenantId: action.id,
          })
          .pipe(
            map((result) =>
              EnquiriesTenantSettings.ResponseSuccessUpdateAction({ payload: result }),
            ),
            catchError((error) =>
              of(
                EnquiriesTenantSettings.ResponseFailUpdateAction({
                  error: error,
                  id: action.id,
                }),
              ),
            ),
          );
      }),
    ),
  );

  getTenantSettingsOnTenantSelection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Tenants.SelectByIdAction),
      withLatestFrom(this.store.select(TenantSelectors.getSelected)),
      filter(([action, tenant]) => tenant?.plan?.hasEnquiries),
      map(([action, selected]) =>
        EnquiriesTenantSettings.RequestRetrieveByIdAction({ id: action.id }),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private enquiriesService: EnquiriesService,
    private store: Store<State>,
  ) {}
}
